import React from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import { createHashHistory } from 'history';
import './App.css';
import SponsorList from './SponsorList';
import SponsorDetail from './SponsorDetail';

const history = createHashHistory()

function App() {
  return (
    <div className="main-container">
      <Router history={history}>
        <Route path="/sponsor-list/:schoolId" component={SponsorList}></Route>
        <Route path="/sponsor-detail/:id" component={SponsorDetail}></Route>
      </Router>
    </div>
  );
}

export default App;
